var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDanskeBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 75.4",
    style: {
      enableBackground: "new 0 0 500 75.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03426A"
    },
    d: "M500,0H321v75.4h179V0z M498,1.9v71.6H322.9V1.9H498"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03426A"
    },
    d: "M0,75.4h313.2V0H0V75.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M498,1.9v71.6H322.9V1.9H498"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M108.2,42.8c0,7.4-4,11.1-12.9,11.1h-14V26.1h13.6c10.8,0,13.4,5.3,13.4,11V42.8z M113.9,42.6v-4.8 c0-15.2-11.9-15.8-20-15.8H75.4V58h20.1C111.3,58,113.9,49.5,113.9,42.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M145.2,49.2c0,2.1-0.2,4-2.6,4.8c-1.4,0.5-3.4,0.7-6.7,0.7c-3.3,0-5.3-0.3-6.5-1.1c-0.8-0.5-1.1-1.3-1.1-3 c0-2.2,0.5-3.4,1.6-3.9c1-0.5,2.4-0.6,6.4-0.6h9L145.2,49.2L145.2,49.2z M150.7,58V43.9c0-2.7,0-4.5-0.2-5.9 c-0.3-1.4-0.7-2.4-1.9-3.3c-2.6-2-9.1-2.1-12.2-2.1c-2.4,0-8.9,0.3-11.3,2.3c-0.8,0.7-1,1.5-1,2.5c0,0.6,0.1,1.5,0.1,2.6h5.3 c0.1-0.6,0.2-2.2,0.8-2.8c0.7-0.7,1.9-1,5.6-1c4.2,0,7.1,0.1,8.3,0.8c1.1,0.6,1.1,2,1.1,3v2.4H133c-3.3,0-7.1,0.1-9.2,2.9 c-1,1.2-1.4,2.8-1.4,4.8c0,6,3.7,8,13.1,8c4.9,0,8.1-0.8,10-2.4l0.5,2.1L150.7,58"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M183.4,58V44.3c0-4.8-0.2-5.7-1.4-6.6c-1.1-0.8-3.3-1.3-6.6-1.3c-2.9,0-5.9,0.4-8.7,1.1V58h-5.4V32.9h4.8 l0.4,1.8c1.1-0.6,1.9-1,3-1.4c1.8-0.5,4.1-0.8,7.1-0.8c3.4,0,6.1,0.5,8.1,1.4c2,0.9,3.1,2.5,3.5,4.4c0.3,1.3,0.4,2.4,0.4,5.3V58 H183.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M223.4,56.5c-2.5,1.3-6.6,1.8-11.9,1.8c-3.7,0-6.7-0.3-9.1-0.9c-2.5-0.6-3.8-1.8-3.9-3.9 c-0.1-1.1,0-2.1,0.1-3.5h5.2c0.2,1.3,0.2,1.7,0.2,1.9c0.2,1.2,0.1,1.8,1.5,2.3c1.4,0.4,3.5,0.6,6.3,0.6c3.4,0,5.8-0.4,7.4-1.1 c1.1-0.5,1.7-1.4,1.7-3.1c0-2-0.4-2.8-2.5-3.1c-0.6-0.1-1.3-0.1-1.9-0.2c-0.4,0-1.5,0-3.4-0.1c-0.9,0-1.9-0.1-3.2-0.1 c-5.4-0.3-11.1-0.5-11.1-6.8c0-5.7,3.5-7.7,13.1-7.7c2.4,0,5.4,0.2,7.2,0.4c2.1,0.3,3.7,0.6,4.8,1.3c1.3,0.7,1.7,1.9,1.7,3.8 c0,0.5,0,1.1-0.1,1.9h-5.3l-0.2-1.1c-0.3-1.4-0.4-1.6-0.8-1.9c-0.8-0.6-3.1-0.9-6.3-0.9s-5.1,0.1-6.6,0.7c-1.4,0.5-2,1.4-2,3.2 c0,1.2,0.5,2.1,1,2.5c1.4,0.9,8.8,0.8,11.4,0.8c2.7,0,4.5,0.3,6,0.8c2.8,1,3.8,2.8,3.8,6.4C226.6,53.5,225.6,55.4,223.4,56.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256.6,58l-13-11.9h-1.9V58h-5.4V22.1h5.4v20.5h1.9l10.8-9.7h6.3l-12.5,11.1L263.8,58H256.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M290.6,43h-17.3c0.2-3.2,0.9-4.6,2.1-5.5c1.3-0.9,3.6-1.4,7-1.4c4.7,0,6.9,1,7.7,3.2 C290.4,40.3,290.6,41.1,290.6,43z M295.6,50.1h-5.3c-0.2,0.8-0.3,2.7-1,3.4c-0.8,0.8-2.4,1.2-6.8,1.2c-4.3,0-6.7-0.6-7.9-1.8 c-0.9-0.9-1.4-2.8-1.4-5.7v-0.7h22.6c0-1.2,0.1-1.5,0.1-2.5c0-4.2-0.6-6.5-2.4-8.2c-2-2.1-6-3.2-11.4-3.2c-6.9,0-11.2,1.6-12.9,5.1 c-1,2-1.6,4.8-1.6,8.3c0,5.5,1.4,8.9,4.7,10.6c2,1.1,5.4,1.7,9.8,1.8c3.7,0,6.6-0.2,9.8-1.1c3.1-1,3.9-2.8,3.9-4.3 C295.7,52.6,295.7,51.4,295.6,50.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03426A"
    },
    d: "M366.9,31.1c0,5.3-3,6.4-9.1,6.4h-13.6V26.1h14.3C363.9,26.1,366.9,26.6,366.9,31.1L366.9,31.1z M374,47.9 c0-4.4-2.5-7.7-8.6-8.6v-0.1c4.7-1.2,7.2-3.7,7.2-7.5c0-6.3-3.1-9.5-11.8-9.5h-22.5V58h23.4C369.6,58,374,54.4,374,47.9L374,47.9z  M368.2,48.3c0,5.1-3.6,5.6-9.2,5.6h-14.8V41.6h15.6C366.4,41.6,368.2,43.7,368.2,48.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03426A"
    },
    d: "M403.4,49.2c0,2.1-0.1,4-2.5,4.8c-1.4,0.5-3.4,0.7-6.7,0.7c-3.3,0-5.3-0.3-6.5-1.1c-0.8-0.5-1.1-1.3-1.1-3 c0-2.2,0.5-3.4,1.6-3.9c1-0.5,2.3-0.6,6.4-0.6h8.9V49.2z M408.9,58V43.9c0-2.7,0-4.5-0.2-5.9c-0.3-1.4-0.7-2.4-1.9-3.3 c-2.6-2-9.1-2.1-12.2-2.1c-2.4,0-8.9,0.3-11.3,2.3c-0.8,0.7-1,1.5-1,2.5c0,0.6,0.1,1.5,0.1,2.6h5.3c0.1-0.6,0.2-2.2,0.8-2.8 c0.7-0.7,1.9-1,5.6-1c4.2,0,7.1,0.1,8.3,0.8c1.1,0.6,1,2,1,3v2.4h-12.2c-3.3,0-7.1,0.1-9.2,2.9c-0.9,1.2-1.4,2.8-1.4,4.8 c0,6,3.7,8,13.1,8c4.9,0,8.1-0.8,10-2.4l0.5,2.1L408.9,58"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03426A"
    },
    d: "M440.3,58V44.3c0-4.8-0.2-5.7-1.4-6.6c-1.1-0.8-3.3-1.3-6.6-1.3c-2.9,0-5.9,0.4-8.7,1.1V58h-5.4V32.9h4.8 l0.4,1.8c1-0.6,1.9-1,3-1.4c1.8-0.5,4-0.8,7.1-0.8c3.4,0,6.1,0.5,8.1,1.4c2,0.9,3.1,2.5,3.5,4.4c0.3,1.3,0.4,2.4,0.4,5.3V58H440.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03426A"
    },
    d: "M475.4,58l-13-11.9h-1.9V58h-5.4V22.1h5.4v20.5h1.9l10.8-9.7h6.3L467,43.9L482.6,58H475.4"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanskeBank);
export default __webpack_public_path__ + "static/media/danske-bank.abb88487cdfcbbfa64c2e0dddb2af2bc.svg";
export { ForwardRef as ReactComponent };